import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../styles/GlobalStyle';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(13, 71, 161, 0.6);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: ${fadeIn} 0.3s ease;
`;

const LoadingCard = styled.div`
  background: white;
  border-radius: 24px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 15px 50px rgba(13, 71, 161, 0.3);
  border: 2px solid ${theme.borderLight};
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(90deg, ${theme.primary}, ${theme.secondary});
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
  }
`;

const LoadingSpinner = styled.div`
  width: 60px;
  height: 60px;
  border: 5px solid rgba(13, 71, 161, 0.1);
  border-top: 5px solid ${theme.primary};
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  animation: ${spin} 1.5s linear infinite;
`;

const LoadingText = styled.p`
  color: ${theme.text};
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  font-family: 'Fredoka', sans-serif;
  animation: ${pulse} 2s infinite;
`;

export const LoadingOverlay = ({ isLoading, message }) => {
  if (!isLoading && !message) return null;
  
  return (
    <OverlayContainer>
      <LoadingCard>
        {isLoading && <LoadingSpinner />}
        {message && <LoadingText>{message}</LoadingText>}
      </LoadingCard>
    </OverlayContainer>
  );
}; 